import PropTypes from 'prop-types'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'

const SuccessAlert = ({ title, show, handleClose, duration }) => {
  return (
    <Snackbar
      open={show}
      autoHideDuration={duration || 4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} severity="success" variant="filled">
        <strong>{title} Success!</strong>
      </Alert>
    </Snackbar>
  )
}
SuccessAlert.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool,
  message: PropTypes.string,
  handleClose: PropTypes.func,
  duration: PropTypes.number,
}

export default SuccessAlert
